document.addEventListener('DOMContentLoaded', () => {
  const controls = document.querySelectorAll('.custom-quick-add');

  if (!controls.length) return;

  async function getCart() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      return await response.json();
    } catch (error) {
      console.error('Could not get cart:', error);
      return null;
    }
  }

  function getProductQuantity(cart, productId) {
    if (!cart) return 0;

    return cart.items
      .filter(item => String(item.product_id) === String(productId))
      .reduce((total, item) => total + item.quantity, 0);
  }

  async function updateQuantityDisplay(control) {
    const productId = control.dataset.productId;
    const quantityElement = control.querySelector('.custom-quick-add__quantity');

    const cart = await getCart();

    if (!cart) return;

    quantityElement.textContent = getProductQuantity(cart, productId);
  }

  async function decreaseQuantity(control) {
    const productId = control.dataset.productId;

    const cart = await getCart();

    if (!cart) return;

    const matchingItem = cart.items.find(
      item => String(item.product_id) === String(productId)
    );

    if (!matchingItem) return;

    const newQuantity = matchingItem.quantity - 1;

    try {
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: matchingItem.key,
          quantity: newQuantity
        })
      });

      await updateQuantityDisplay(control);

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
      console.error('Could not decrease quantity:', error);
    }
  }

  controls.forEach(control => {
    const plusButton = control.querySelector('.custom-quick-add__plus');
    const minusButton = control.querySelector('.custom-quick-add__minus');
    const cartButton = control.querySelector('.custom-quick-add__cart');

    /*
     * + BUTTON
     *
     * Opens Dawn's existing Quick Add / size-selection popup.
     */
    plusButton.addEventListener('click', () => {
      const modalOpener = control.querySelector(
        '.custom-quick-add__modal-opener'
      );

      const modalButton = modalOpener?.querySelector('button');

      if (modalButton) {
        modalButton.click();

        /*
         * Wait for the Quick Add modal to finish adding
         * the product, then refresh the displayed quantity.
         */
        let attempts = 0;

        const checkCart = setInterval(async () => {
          attempts++;

          await updateQuantityDisplay(control);

          if (attempts >= 20) {
            clearInterval(checkCart);
          }
        }, 500);
      }
    });

    /*
     * - BUTTON
     */
    minusButton.addEventListener('click', () => {
      decreaseQuantity(control);
    });
    cartButton.addEventListener('click', () => {
  const plusButton = control.querySelector('.custom-quick-add__plus');

  if (plusButton) {
    plusButton.click();
  }
});

    /*
     * Get the existing cart quantity when the page loads.
     */
    updateQuantityDisplay(control);
  });
});